module.exports = __webpack_public_path__ + "static/media/talksCardBack.6ac91b16.svg";